import { Routine } from 'redux-saga-routines';
import {
  fetchProspectsRoutine,
  fetchProspectCountersRoutine,
  updateProspectFilterRoutine
} from '../../routines';
import { IProspect } from '../../../../common/models/prospect/IProspect';
import { ProspectStatus } from '../../../../common/enums/ProspectStatus';
import { AssignmentFilterType } from '../../../../common/enums/AssignmentFilterType';
import { IFilter } from '../../../../common/models/filter/IFilter';

export type ProspectState = {
  prospects: IProspect[];
  total: number;
  loading: boolean;
  counters: Record<ProspectStatus, number> | undefined;
  assignmentFilter: AssignmentFilterType;
  filter?: IFilter;
};

const initialState: ProspectState = {
  prospects: [],
  total: 0,
  loading: true,
  counters: undefined,
  assignmentFilter: AssignmentFilterType.Me
};

export const prospects = (state: ProspectState = initialState, { type, payload }: Routine<any>) => {
  switch (type) {
    case fetchProspectsRoutine.TRIGGER:
      return {
        ...state,
        loading: true
      };
    case fetchProspectsRoutine.SUCCESS:
      const items = payload.reset ? payload.items : [...state.prospects, ...payload.items];
      return {
        ...state,
        loading: false,
        prospects: items,
        total: payload.total
      };
    case fetchProspectsRoutine.FAILURE:
      return {
        ...state,
        loading: false
      };
    case fetchProspectCountersRoutine.SUCCESS:
      return {
        ...state,
        counters: payload
      };
    case updateProspectFilterRoutine.TRIGGER: {
      const { filter, assignmentFilter } = payload;
      return {
        ...state,
        filter,
        assignmentFilter: assignmentFilter || state.assignmentFilter
      };
    }
    default:
      return state;
  }
};
